// tslint:disable:max-line-length

import React from 'react';

export const EditorBlockquote = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,1v7h4c0,2.2-1.8,4-4,4v3c3.8,0,7-3.2,7-7V1H0z M9,1v7h4c0,2.2-1.8,4-4,4v3c3.8,0,7-3.2,7-7V1H9z" />
    </svg>
  );
};
